import List from "@/components/list";
import { tableBaseProps } from "@/utils/common.js";

const Table = (args) => {
  const { listeners } = args;
  // const RCSelectionChange = listeners["selection-change"] || function () { };
  // const showTestReportImg = listeners["showTestReportImg"] || function () { };
  // const showHealthReportImg = listeners["showHealthReportImg"] || function () { };
  const handleCheck = listeners["handleCheck"] || function() {};
  const lookRemark = listeners["lookRemark"] || function() {};
  const seeLeaveInfo = listeners["seeLeaveInfo"] || function() {};

  const Deal = ({ props: { vo } }) => {
    const curItem = vo.row;
    let dealConf = [];
    dealConf.push([
      "iconfont ic_checkinmanagement iconfont-adapt",
      "手动报到",
      () => handleCheck(curItem),
      "enroll:updateClockStatus",
    ]);
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const ClockTime = ({ props: { vo } }) => {
    const clockTime = vo.row.clockTime ? vo.row.clockTime : "--";
    return <span>{clockTime}</span>;
  };

  const Remarks = ({ props: { vo } }) => {
    const { row } = vo;
    const { remarks } = row;
    return (
      <div>
        {row.auditUuids && row.auditUuids.length > 0 ? <div class="base-hover-char " onClick={() => seeLeaveInfo(row)}>查看请假记录</div> : null}
        {remarks ? (
          <div
            class="base-hover-char ellipsis--l2"
            style={'color: #51627d'}
            onClick={() => lookRemark(row)}
          >
            {remarks}
          </div>
        ) : null}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: " 所属分组",
      prop: "groupName",
      width: "90",
    },
    {
      label: "姓名",
      prop: "userName",
      width: "90",
    },
    {
      label: "手机号码",
      prop: "userMobile",
      width: "120",
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      width: "250",
      showOverflowTooltip: true,
    },
    // {
    //   label: "健康申报承诺书",
    //   prop: "healthReport",
    //   width: "110",
    //   render: vo => {
    //     if (vo.row.healthReport) {
    //       return (
    //         <el-button
    //           class="no-padding"
    //           size="small"
    //           type="text"
    //           onClick={() => showHealthReportImg(vo.row)}
    //         >预览
    //         </el-button>
    //       );
    //     } else {
    //       return (<span>--</span>);
    //     }
    //   }
    // },
    // {
    //   label: "核酸检测报告",
    //   prop: "testReport",
    //   width: "110",
    //   render: vo => {
    //     if (vo.row.testReport) {
    //       return (
    //         <el-button
    //           class="no-padding"
    //           size="small"
    //           type="text"
    //           onClick={() => showTestReportImg(vo.row)}
    //         >预览
    //         </el-button>
    //       );
    //     } else {
    //       return (<span>--</span>);
    //     }
    //   }
    // },
    {
      label: "报到时间",
      prop: "clockTime",
      width: "160",
      render: (vo) => <ClockTime vo={vo} />,
    },
    {
      label: "报到状态",
      prop: "clockStatusName",
      width: "80",
    },
    {
      ...tableBaseProps("备注", "remarks", "150", false),
      render: (vo) => <Remarks vo={vo} />,
    },
    {
      label: "操作",
      width: "80",
      // fixed: "right",
      render: (vo) => <Deal vo={vo} />,
    },
  ];

  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};

export default Table;
